import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50/80">
      <div className="px-4 md:px-6 py-14">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <h3 className="font-heading text-lg font-semibold text-background-50 mb-4">水野朝阳官方粉丝站</h3>
              <p className="text-sm text-background-50/60 leading-relaxed">
                最权威、最全面的水野朝阳信息聚合平台，为全球粉丝提供一站式资讯服务。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">快速导航</h4>
              <div className="flex flex-col gap-2.5">
                <Link to="/" className="text-sm text-background-50/60 hover:text-accent-400 transition-colors">首页</Link>
                <Link to="/category/all" className="text-sm text-background-50/60 hover:text-accent-400 transition-colors">作品浏览</Link>
                <Link to="/about" className="text-sm text-background-50/60 hover:text-accent-400 transition-colors">关于我们</Link>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">分类浏览</h4>
              <div className="flex flex-col gap-2.5">
                <Link to="/category/drama" className="text-sm text-background-50/60 hover:text-accent-400 transition-colors">剧情系列</Link>
                <Link to="/category/youth" className="text-sm text-background-50/60 hover:text-accent-400 transition-colors">青春系列</Link>
                <Link to="/category/urban" className="text-sm text-background-50/60 hover:text-accent-400 transition-colors">都市系列</Link>
                <Link to="/category/news" className="text-sm text-background-50/60 hover:text-accent-400 transition-colors">活动报道</Link>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">关注我们</h4>
              <div className="flex items-center gap-4">
                <a
                  href="https://twitter.com/mizuno_asahi"
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="w-10 h-10 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-accent-500 transition-colors"
                  aria-label="Twitter"
                >
                  <i className="ri-twitter-x-line text-background-50 text-lg" />
                </a>
                <a
                  href="https://instagram.com/mizuno_asahi"
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="w-10 h-10 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-accent-500 transition-colors"
                  aria-label="Instagram"
                >
                  <i className="ri-instagram-line text-background-50 text-lg" />
                </a>
              </div>
              <p className="mt-4 text-xs text-background-50/40">
                联系邮箱：contact@mizuno-asahi-fans.com
              </p>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-50/40">
              &copy; {new Date().getFullYear()} 水野朝阳官方粉丝站 · 版权所有
            </p>
            <p className="text-xs text-background-50/30">
              本站为非营利性粉丝信息聚合平台
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}